import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgRetroCreditTermsAndConditions',
})
export default class CmgRetroCreditTermsAndConditions extends Vue {
  get customerServiceUrl(): string {
    return this.$services.config.getSupportUrl();
  }

  get legalCopy(): string {
    return this.$services.config.getLegalText().retroCredit;
  }
}
